export class ErrorWarningMessage {
  constructor(public type: string, public message: string) {}
}
